import React from "react";
import ReporteComisionesVendedores from "../components/ReporteComisionesVendedores";

const InformeComisionesVendedores = () => {
  return (
    <>
      <ReporteComisionesVendedores />
    </>
  );
};

export default InformeComisionesVendedores;